import React from "react";
import { useI18n } from "@/i18n/I18nContext";
import { CONTACT } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import { Car, Plane, Train, Ship, ParkingCircle, Lightbulb, MapPin, Footprints, Bus } from "lucide-react";

const ITEMS = [
  { k: "car", Icon: Car },
  { k: "airport", Icon: Plane },
  { k: "train", Icon: Train },
  { k: "boat", Icon: Ship },
  { k: "walk", Icon: Footprints },
  { k: "bus", Icon: Bus },
  { k: "parking", Icon: ParkingCircle },
  { k: "tips", Icon: Lightbulb },
];

export default function LocationPage() {
  const { t } = useI18n();
  return (
    <>
      <section className="pt-36 pb-12 bg-[#F2EFEB]">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <Reveal>
            <h1 className="font-display text-5xl md:text-6xl text-[#1A1A1A] tracking-tight">{t("location.title")}</h1>
            <p className="mt-5 text-lg text-[#5C5C5C]">{t("location.subtitle")}</p>
            <a href={`https://www.google.com/maps/dir/?api=1&destination=${CONTACT.mapsQuery}`}
               target="_blank" rel="noopener noreferrer" data-testid="location-directions-btn"
               className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#345B73] text-white font-medium hover:bg-[#2B4A5D] transition-all">
              <MapPin className="w-4 h-4" /> {t("common.openMaps")}
            </a>
          </Reveal>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-6xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-6">
          {ITEMS.map((it, i) => (
            <Reveal key={it.k} delay={i * 60}>
              <div data-testid={`travel-card-${it.k}`} className="p-8 rounded-2xl bg-white border border-black/5 h-full">
                <it.Icon className="w-7 h-7 text-[#345B73] mb-4" />
                <h3 className="font-display text-2xl text-[#1A1A1A] mb-3">{t(`location.${it.k}.t`)}</h3>
                <p className="text-[#5C5C5C] leading-relaxed">{t(`location.${it.k}.d`)}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <div className="aspect-[16/9] rounded-2xl overflow-hidden shadow-sm">
            <iframe title="map" src={`https://www.google.com/maps?q=${CONTACT.mapsQuery}&output=embed`} className="w-full h-full border-0" loading="lazy" />
          </div>
        </div>
      </section>
    </>
  );
}
